module.exports = __webpack_public_path__ + "static/media/img-thumbnail-sushi-04.cec30334.webp";